import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'

//svg-icon註冊到全局
Vue.component('svg-icon', SvgIcon)

//import全部符合的檔案
const requireAll = requireContext => requireContext.keys().map(requireContext)
//require.context(路徑, 是否包含子目錄, 需要正規表達)
const req = require.context('@/assets/icons', false, /\.svg$/)
requireAll(req)
